import { AfterViewInit, Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { SnackService } from '../../service/snack.service';

@Component({
    selector: 'app-confirm-email',
    standalone: false,

    templateUrl: './confirm-email.component.html',
    styleUrl: './confirm-email.component.scss'
})
export class ConfirmEmailComponent implements AfterViewInit {
    confirmId: string | undefined = "";
    showError: boolean = false;

    // Get id from Url
    constructor(
        private authService: AuthandregistryService,
        private snack: SnackService,
    ) {
        this.confirmId = window.location.href.split('/').pop();
        this.confirmId = this.confirmId?.split('?')[0];
    }
    ngAfterViewInit(): void {
        this.confirm();
    }
    async confirm() {
        if (!this.confirmId) {
            this.snack.error({ error: { msg: { headline: "Missing Data", text: "Confirm your Email not possible. Please contact the support." } } });
            return;
        }

        const result = await this.authService.confirmEmail(this.confirmId);

        if (
            result !== true ||
            typeof result === 'number'
        ) {
            this.showError = true;
        }

    }
}
